"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMarkActive = void 0;
const slate_1 = require("slate");
exports.isMarkActive = (editor, format) => {
    const marks = slate_1.Editor.marks(editor);
    return marks ? !!marks[format] === true : false;
};
//# sourceMappingURL=is-mark-active.js.map